import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "./router/index.js";
import App from "./App.vue";
import "./style.css";
import "../styles.css";

import { onAuthStateChanged } from "firebase/auth";
import { onSnapshot, doc, collection, query, where } from "firebase/firestore";
import { watch } from "vue";
import { auth, db } from "./firebase";
import { useAuthStore } from "./stores/authStore";
import { wsManager } from "./services/wsManager";
import { resolveTenant } from "./services/authService";

const app   = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.mount("#app");

let userDocUnsub     = null;
let notifUnsub       = null;

onAuthStateChanged(auth, async (user) => {
  const authStore = useAuthStore();

  if (userDocUnsub) { userDocUnsub(); userDocUnsub = null; }
  if (notifUnsub)   { notifUnsub();   notifUnsub   = null; }

  if (user) {
    authStore.setUser(user);

    const tenant = await resolveTenant(user.uid, user.email);
    if (tenant) {
      authStore.setTenant(tenant);

      // Admin notifications listener
      if (tenant.role === "admin") {
        notifUnsub = onSnapshot(
          query(
            collection(db, "tenants", tenant.tenantId, "notifications"),
            where("read", "==", false)
          ),
          (snap) => {
            authStore.notifications = snap.docs.map(d => ({ id: d.id, ...d.data() }));
          }
        );
      }
    }

    // Watch apiBase — connect on first set and reconnect on workspace switch
    watch(
      () => authStore.apiBase,
      (newBase, oldBase) => {
        if (newBase && newBase !== oldBase) {
          wsManager.disconnect();
          wsManager.connect();
        }
      },
      { immediate: true }
    );

    // Real-time listener on /users/{uid}
    userDocUnsub = onSnapshot(doc(db, "users", user.uid), async (snap) => {
      if (!snap.exists()) return;
      const data    = snap.data();
      const tenants = data.tenants ?? [{ tenantId: data.tenantId, role: data.role }];

      const activeTenant = tenants.find(t => t.tenantId === authStore.tenantId);
      if (!activeTenant && tenants.length > 0) {
        console.log("[Auth] Active tenant removed — switching to:", tenants[0].tenantId);
        const result = await resolveTenant(user.uid, user.email, tenants[0].tenantId);
        if (result) authStore.setTenant(result);
        return;
      }

      if (activeTenant && activeTenant.role !== authStore.role) {
        console.log("[Auth] Role updated remotely:", activeTenant.role);
        authStore.setTenant({ ...authStore.$state, role: activeTenant.role });
      }

      authStore.setTenant({ ...authStore.$state, tenants });
    });

  } else {
    authStore.clearUser();
    wsManager.disconnect();
  }
});